module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular.7f9bf47a.woff2";